import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const faqs = [{
    q: '¿Sirve para todos los años?',
    a: 'Sí. Está adaptado para secundaria técnica, con contenidos que podés usar en distintos niveles y materias del área agro.'
  }, {
    q: '¿Cómo recibo el material?',
    a: 'Es 100% digital. Descargás todos los PDFs al instante y los podés usar en clase o imprimir.'
  }, {
    q: '¿Qué lo diferencia del material online?',
    a: 'Todo está pensado para el contexto agropecuario argentino. No es contenido urbano adaptado. Es contenido creado directamente para el campo.'
  }, {
    q: '¿Tiene garantía real?',
    a: 'Sí. Tenés 7 días para probarlo. Si no te sirve, te devolvemos el 100%.'
  }, {
    q: '¿Funciona para escuelas con pluricurso?',
    a: 'Sí. El material incluye adaptaciones para trabajar con distintos niveles en el mismo espacio, ideal para escuelas rurales.'
  }, {
    q: '¿Puedo imprimir los materiales?',
    a: 'Sí. Todos los PDFs están optimizados para impresión en blanco y negro o color.'
  }, {
    q: '¿Está actualizado a los diseños curriculares?',
    a: 'Sí. Los contenidos están alineados con los NAP y cubren los ejes de economía y producción agropecuaria.'
  }, {
    q: '¿Necesito internet en el aula?',
    a: 'No. Una vez descargados, podés usarlos offline, ideal para escuelas rurales con poca conectividad.'
  }, {
    q: '¿Sirve si doy otras materias del área agro?',
    a: 'Sí. El material articula con Producción Agropecuaria, Gestión, Administración Rural y materias afines.'
  }, {
    q: '¿Hay que pagar mensualidad?',
    a: 'No. Es un pago único. Comprás el kit hoy y te queda para siempre.'
  }];
  return <section className="py-10 md:py-16 px-4 bg-brand-card" data-id="element-47">
      <div className="max-w-3xl mx-auto" data-id="element-48">
        <h2 className="text-2xl md:text-4xl font-black text-center mb-8 text-white" data-id="element-49">
          ❓ LO QUE MÁS NOS PREGUNTAN
        </h2>

        <div className="space-y-3" data-id="element-50">
          {faqs.map((faq, index) => <div key={index} className={`bg-brand-dark rounded-lg border ${openIndex === index ? 'border-brand-accent/50' : 'border-white/10'} overflow-hidden transition-all duration-200`} data-id="element-51">
              <button className="w-full px-4 py-3 md:px-5 md:py-4 text-left flex justify-between items-center focus:outline-none" onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-52">
                <span className={`font-bold text-sm md:text-base pr-4 ${openIndex === index ? 'text-brand-accent' : 'text-gray-200'}`} data-id="element-53">
                  {faq.q}
                </span>
                {openIndex === index ? <ChevronUp className="w-5 h-5 text-brand-accent shrink-0" data-id="element-54" /> : <ChevronDown className="w-5 h-5 text-gray-600 shrink-0" data-id="element-55" />}
              </button>

              <div className={`px-4 md:px-5 overflow-hidden transition-all duration-300 ease-in-out ${openIndex === index ? 'max-h-96 pb-4 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-56">
                <p className="text-sm md:text-base text-gray-400 leading-relaxed pt-2 border-t border-white/5" data-id="element-57">
                  {faq.a}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}